(() => {
  'use strict';
  const page = document.getElementById('clothing-page');
  if (!page || page.dataset.ready) return;
  page.dataset.ready = 'true';
  const config = JSON.parse(document.getElementById('clothing-config').textContent);
  const $ = selector => page.querySelector(selector);
  const form = $('#clothing-form'), status = $('#clothing-status'), button = $('.clothing-add[type="submit"]');
  const quantity = $('#clothing-quantity'), fast = $('#clothing-fast'), layerSelect = $('#clothing-layers');
  const strings = config.strings;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:config.currency || 'USD'}).format(cents / 100);
  const byId = id => config.variants.find(v => Number(v.id) === Number(id));
  let placement = config.placements[0], size = placement.sizes[placement.default];
  let files = [], busy = false, completed = false, engineReady = false, syncing = false;
  const savedSizes = new Map();
  const qty = () => Math.max(1, Math.floor(Number(quantity.value) || 1));
  const variant = () => byId(size.id);
  const block = () => $('#clothing-ymq ymq-option');
  const engineSelect = () => block()?.querySelector('[ymq-option-id="8"] select');
  const sizeText = item => item.w + ' × ' + item.h + '″';
  function setText(selector, text) { const element = $(selector); if (element) element.textContent = text; }
  function drawSizes() {
    $('#clothing-sizes').replaceChildren();
    placement.sizes.forEach(item => {
      const v = byId(item.id), label = document.createElement('label'), input = document.createElement('input');
      const body = document.createElement('span'), title = document.createElement('b'), price = document.createElement('small');
      label.className = 'clothing-size-pill'; input.type = 'radio'; input.name = 'clothing-size'; input.value = item.id;
      input.checked = item.id === size.id; input.disabled = !v || !v.available;
      title.textContent = sizeText(item); price.textContent = v ? money(v.price) : strings.unavailable;
      input.addEventListener('change', () => { size = item; savedSizes.set(placement.key, item.id); changeSelection(); });
      body.append(title, price); label.append(input, body); $('#clothing-sizes').append(label);
    });
  }
  function updateLayerLabels() {
    const source = engineSelect(); if (!source) return;
    const chosen = source.value;
    layerSelect.replaceChildren(...Array.from(source.options).filter(option => option.value).map(option => {
      const copy = document.createElement('option'); copy.value = option.value;
      copy.textContent = option.textContent.replace(/\s+/g, ' ').trim(); copy.selected = option.value === chosen;
      return copy;
    }));
    layerSelect.disabled = busy;
  }
  function syncEngine() {
    if (!engineReady || syncing) return;
    syncing = true;
    try {
      const b = block();
      window.ymqOption.variantChangeApp(b, size.id);
      b._setBlockConfig({quantity:qty()});
      window.ymqOption.buildFormData(b);
      updateLayerLabels();
    } finally { syncing = false; }
  }
  function render() {
    const v = variant(), prices = engineReady ? window.ymqOption.productPrice(block()) : null;
    const unit = prices ? Math.round(prices.productPrice * 100) : v?.price || 0;
    const subtotal = prices ? Math.round(prices.totalProductPrice * 100) : unit * qty();
    const extra = fast.checked && !fast.disabled ? Number(fast.dataset.price) : 0;
    $('#clothing-variant').value = v?.id || '';
    $('#clothing-placement-property').value = placement.label;
    $('#clothing-size-property').value = size.w + ' × ' + size.h + ' inches';
    setText('[data-selection-note]', placement.label + ' · ' + sizeText(size) + ' · ' + placement.position);
    setText('[data-main-price]', money(unit)); setText('[data-set-price]', money(subtotal));
    setText('[data-total]', money(subtotal + extra)); setText('[data-button-price]', money(subtotal + extra));
    setText('[data-fast-price]', money(extra)); $('[data-fast-row]').hidden = !extra;
    $('[data-quantity-minus]').disabled = qty() <= 1 || busy;
    setText('[data-add-label]', busy ? strings.adding : completed ? strings.added : v?.available ? strings.add : strings.unavailable);
    button.disabled = busy || completed || !engineReady || !v?.available;
    form.setAttribute('aria-busy', String(busy));
  }
  function changeSelection() {
    $('#clothing-variant').value = size.id;
    const url = new URL(window.location.href); url.searchParams.set('variant', size.id);
    window.history.replaceState(window.history.state, '', url);
    syncEngine(); render();
  }
  function choosePlacement(key) {
    placement = config.placements.find(item => item.key === key) || config.placements[0];
    size = placement.sizes.find(item => item.id === savedSizes.get(key)) || placement.sizes[placement.default];
    page.querySelectorAll('[name="clothing-placement"]').forEach(input => { input.checked = input.value === placement.key; });
    drawSizes(); changeSelection();
  }
  const requested = Number(new URL(window.location.href).searchParams.get('variant'));
  const matching = config.placements.find(area => area.sizes.some(item => item.id === requested));
  if (matching) { placement = matching; size = matching.sizes.find(item => item.id === requested); }
  page.querySelectorAll('[name="clothing-placement"]').forEach(input => {
    input.checked = input.value === placement.key;
    input.addEventListener('change', () => choosePlacement(input.value));
  });
  document.querySelectorAll('[data-guide-placement]').forEach(item => item.addEventListener('click', () => {
    choosePlacement(item.dataset.guidePlacement); form.scrollIntoView({behavior:'smooth',block:'start'});
  }));
  quantity.addEventListener('input', () => { syncEngine(); render(); });
  quantity.addEventListener('change', () => { quantity.value = qty(); syncEngine(); render(); });
  $('[data-quantity-minus]').addEventListener('click', () => { quantity.value = Math.max(1, qty() - 1); syncEngine(); render(); });
  $('[data-quantity-plus]').addEventListener('click', () => { quantity.value = qty() + 1; syncEngine(); render(); });
  fast.addEventListener('change', render);
  layerSelect.addEventListener('change', () => {
    if (!engineReady) return;
    const source = engineSelect(), wrapper = source.closest('[ymq-option-id="8"]');
    const custom = window.ymqOption._getSelect(wrapper);
    if (custom) custom.setSelected(layerSelect.value);
    else { source.value = layerSelect.value; source.dispatchEvent(new Event('change', {bubbles:true})); }
    syncEngine(); render();
  });
  form.addEventListener('click', event => event.stopPropagation());
  page.querySelectorAll('details > summary').forEach(summary => summary.addEventListener('click', event => {
    event.preventDefault(); event.stopPropagation(); summary.parentElement.open = !summary.parentElement.open;
  }));
  page.querySelectorAll('[data-gallery]').forEach(item => item.addEventListener('click', () => {
    $('#clothing-main-image').src = item.dataset.gallery; $('#clothing-main-image').alt = item.dataset.alt;
    page.querySelectorAll('[data-gallery]').forEach(other => other.setAttribute('aria-pressed', String(other === item)));
  }));
  function renderFiles() {
    $('#clothing-file-list').replaceChildren();
    files.forEach((file, index) => {
      const row = document.createElement('li'), name = document.createElement('span'), remove = document.createElement('button');
      name.textContent = file.name; remove.type = 'button'; remove.textContent = strings.remove;
      remove.setAttribute('aria-label', strings.remove + ' ' + file.name);
      remove.addEventListener('click', () => { files.splice(index, 1); renderFiles(); });
      row.append(name, remove); $('#clothing-file-list').append(row);
    });
  }
  $('#clothing-upload').addEventListener('change', event => {
    files.push(...Array.from(event.target.files)); event.target.value = ''; renderFiles();
  });
  window.addEventListener('click', event => {
    if (!event.target.closest('#clothing-form .clothing-add')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (!button.disabled) form.requestSubmit();
  }, true);
  window.addEventListener('submit', async event => {
    if (event.target !== form) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (busy || completed || !engineReady || !variant()?.available || !form.reportValidity()) return;
    syncEngine();
    busy = true; status.textContent = ''; status.setAttribute('role', 'status'); render();
    try {
      quantity.value = qty();
      const data = new FormData(form);
      data.delete('clothing-size'); data.delete('clothing-placement');
      data.set('id', size.id); data.set('quantity', qty());
      files.forEach((file, index) => data.append('properties[Artwork ' + (index + 1) + ']', file, file.name));
      if (!files.length) data.set('properties[Artwork]', strings.later);
      const response = await fetch(config.root + 'cart/add.js', {method:'POST', body:data, headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || strings.error);
      completed = true;
      if (fast.checked && !fast.disabled) {
        const cartResponse = await fetch(config.root + 'cart.js', {headers:{Accept:'application/json'}});
        if (!cartResponse.ok) throw new Error(strings.fast_error);
        const cart = await cartResponse.json(), fastId = Number(fast.dataset.id);
        if (!cart.items.some(item => item.variant_id === fastId)) {
          const fastResponse = await fetch(config.root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:fastId,quantity:1}]})});
          if (!fastResponse.ok) throw new Error(strings.fast_error);
        }
      }
      window.location.assign(config.root + 'cart');
    } catch (error) {
      status.setAttribute('role', 'alert'); status.textContent = error.message || strings.error;
      if (completed) {
        const link = document.createElement('a'); link.href = config.root + 'cart'; link.textContent = ' ' + strings.view_cart; status.append(link);
      }
    } finally { busy = false; render(); }
  }, true);
  document.querySelectorAll('header.header a[href="/products/custom-stencils#pp-form"]').forEach(link => { link.href = '#clothing-form'; });
  drawSizes(); render();
  let readinessTimer;
  const optionObserver = new MutationObserver(initializeOptions);
  const readinessPoll = setInterval(initializeOptions, 500);
  function initializeOptions() {
    if (engineReady) return;
    const b = block(), source = engineSelect();
    if (window.ymqOption && b?._getBlockConfig && source?.options.length > 1) {
      optionObserver.disconnect(); clearTimeout(readinessTimer); clearInterval(readinessPoll);
      engineReady = true; page.dataset.engineReady = 'true'; status.textContent = '';
      syncEngine(); render();
      if (window.ymqOptionEvent) window.ymqOptionEvent.on('afterOptionChange', event => {
        if (event.blockElement?.closest('#clothing-ymq') && !syncing) { updateLayerLabels(); render(); }
      });
    }
  }
  optionObserver.observe(block(), {childList:true,subtree:true});
  window.__ymqOptionReady ??= new Promise(resolve => { window.__ymqOptionReadyResolve = resolve; });
  window.__ymqOptionReady.then(initializeOptions);
  function waitForOptions() {
    if (engineReady || readinessTimer) return;
    readinessTimer = setTimeout(() => { if (!engineReady) status.textContent = strings.engine_error; }, 45000);
  }
  page.addEventListener('pointerdown', waitForOptions, {once:true});
  page.addEventListener('keydown', waitForOptions, {once:true});
  window.addEventListener('pagehide', () => { optionObserver.disconnect(); clearTimeout(readinessTimer); clearInterval(readinessPoll); }, {once:true});
  initializeOptions();
})();
